export { default } from './ContestPlacesItem';



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/ContestPlacesList/ContestPlacesItem/index.js